import ChatMessageForm from "./chat-message-form";

export default ChatMessageForm;